import type { Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

/**
 * Links inside an answer — the ticket links above all, since a ticket list puts
 * one in every row and an underline on each turns the table into noise.
 *
 * Merged after SafeHtmlRenderer's own `& a` (purple, underlined) and after the
 * table's `& td`, both of which it has to beat. Hover, active and visited hold
 * the same colour on purpose: a colour that moves under the cursor reads as a
 * state change in a thread the user is only reading.
 */
export const answerLinkSx = (theme: Theme): SystemStyleObject<Theme> => ({
  "& a": {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover, &:active, &:visited, &:focus-visible": {
      color: theme.palette.primary.main,
      textDecoration: "none",
    },
  },
});
